import React, { useState } from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { Container, Grid, Link } from '@toptal/picasso'
import { Plus, Minus } from '@toptal/picasso/Icon'

import ButtonGroup from '../ButtonGroup/ButtonGroup'

import { separatorChanged, wrapperChanged } from '../../actions'
import { IExtraOption, IStoreState, SEPARATORS, WRAPPERS } from '../../utils'

const StyledIcon = styled.span`
  padding-right: 0.25rem;
`

const Accordion = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease-out;

  &.opened {
    max-height: 160px;
  }
`

interface IProps {
  separator: IExtraOption
  wrapper: IExtraOption
  title: string
  onSeparatorChanged(kind: string): void
  onWrapperChanged(kind: string): void
}

const ExtraOptions: React.FunctionComponent<IProps> = props => {
  const [opened, setOpened] = useState(false)

  const handleOptionsClick = (event: React.MouseEvent) => {
    event.preventDefault()
    setOpened(!opened)
  }

  return (
    <React.Fragment>
      <Grid>
        <Grid.Item small={12}>
          <Link tabIndex={0} onClick={handleOptionsClick}>
            <StyledIcon>
              {!opened && <Plus size={0.8} />}
              {opened && <Minus size={0.8} />}
            </StyledIcon>
            {props.title}
          </Link>
        </Grid.Item>
      </Grid>
      <Accordion className={opened ? 'opened' : ''}>
        <Container top='small'>
          <Grid spacing={16}>
            <Grid.Item small={12} large={8}>
              <ButtonGroup
                title='Separator'
                activeKind={props.separator.kind}
                onChange={props.onSeparatorChanged}
                buttons={[...SEPARATORS]}
              />
            </Grid.Item>
            <Grid.Item small={12} large={4}>
              <ButtonGroup
                title='Wrap in'
                activeKind={props.wrapper.kind}
                onChange={props.onWrapperChanged}
                buttons={[...WRAPPERS]}
              />
            </Grid.Item>
          </Grid>
        </Container>
      </Accordion>
    </React.Fragment>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  separator: state.separator,
  wrapper: state.wrapper
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSeparatorChanged: (kind: string) => {
    dispatch(separatorChanged(kind))
  },
  onWrapperChanged: (kind: string) => {
    dispatch(wrapperChanged(kind))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExtraOptions)
